import React, { useEffect, useState, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";
import LeaseApiService from '../../services/apiService';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const ImagesList = ({ attachments, setDeletedFiles, deletedFiles, setAttachments, createEmptyRow }) => {
    const apiService = new LeaseApiService();

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewType, setPreviewType] = useState("");
    const [previewImage, setPreviewImage] = useState(null);
    let readOnly = false
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true,   // ✅ mark new
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = async (row) => {
        if (!row.isNew) {
            setDeletedFiles((prev) => [...prev, row.fileName]);
            // const fileparams = new URLSearchParams();
            // fileparams.append('filePath', row?.filePath);
            // const imgRes = await apiService.deleteParameter('DELETE_FILE', `?${fileparams.toString()}`);
        }

        setAttachments((prev) => prev.filter((item) => item.id !== row.id));
    };
    const handleView = (row) => {
        if (!row) return;

        let fileUrl = "";
        let fileType = "";

        if (row.isNew) {
            fileUrl = URL.createObjectURL(row.file);
            fileType = row.file?.type || "";
        } else {
            fileUrl = row.fullUrl;

            const extension = row.fileName?.split(".").pop()?.toLowerCase();

            if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) {
                fileType = "image";
            } else if (extension === "pdf") {
                fileType = "application/pdf";
            } else if (["txt", "csv"].includes(extension)) {
                fileType = "text/plain";
            } else {
                fileType = "other";
            }
        }

        setPreviewImage(fileUrl);
        setPreviewType(fileType);
        setPreviewModal(true);
    };
    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>File Name</th>
                        <th>Remarks</th>
                        <th>Upload</th>
                        <th>View</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <input disabled value={row.fileName} className="form-control" />
                            </td>

                            <td>
                                <input
                                    disabled={readOnly}
                                    value={row.remarks}
                                    className="form-control"
                                    onChange={(e) =>
                                        handleRemarkChange(row.id, e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="file"
                                    hidden
                                    id={`file-${row.id}`}
                                    onChange={(e) =>
                                        handleFileSelect(e.target.files[0], row.id)
                                    }
                                />
                                <button
                                    className="mainbtn"
                                    onClick={() =>
                                        document.getElementById(`file-${row.id}`).click()
                                    }
                                >
                                    Upload
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnRed"
                                    disabled={!row.fileName}
                                    onClick={() => handleView(row)}
                                >
                                    View
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnSecondary"
                                    onClick={() => handleDelete(row)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal
                show={previewModal}
                size="lg"
                onHide={() => setPreviewModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: "500px" }}>
                    {!previewImage ? null : previewType.startsWith("image") ? (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{ width: "100%" }}
                        />
                    ) : previewType === "application/pdf" ? (
                        <iframe
                            src={previewImage}
                            title="PDF Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        />
                    ) : previewType.startsWith("text") ? (
                        <iframe
                            src={previewImage}
                            title="Text Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        />
                    ) : (
                        <div className="text-center">
                            <p>Preview is not available for this file type.</p>

                            <a
                                href={previewImage}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary"
                            >
                                Open File
                            </a>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setPreviewModal(false)}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ImagesList